import React from 'react'
import { Text, Flex } from 'components/ds'
import { TRACK } from '@disco/constants/ItemTypes'
import FileIcon from 'components/common/tracks/track-artwork/file-icon'
import { getFileTypeByExt } from '@disco/utils/file-utils'
import type { Track } from 'types/track'
import styles from './index.module.css'

type DraggableItem = { id: string | number; type?: string }

type Props = {
  track: DraggableItem
}

const isTrack = (item: DraggableItem): item is Track => item.type === TRACK

const DraggableTrackPreview = ({ track }: Props) => {
  if (!isTrack(track)) {
    return null
  }

  return (
    <Flex align="center" gap="2" p="2" className={styles.DraggableTrackPreview}>
      <Flex className={styles.DraggableTrackPreview__artwork}>
        {track.artwork_sizes?.['160x160'] ? (
          <img
            src={track.artwork_sizes?.['160x160']}
            alt="Artwork"
            className={styles.DraggableTrackPreview__artworkImage}
          />
        ) : (
          <div className={styles.DraggableTrackPreview__artworkFallback}>
            <FileIcon fileType={getFileTypeByExt(track.ext)} size="small" />
          </div>
        )}
      </Flex>
      <Flex
        direction="column"
        className={styles.DraggableTrackPreview__textContainer}
      >
        <Text className={styles.DraggableTrackPreview__title}>
          {track.name}
        </Text>
        <Text className={styles.DraggableTrackPreview__artist}>
          {track.artist}
        </Text>
      </Flex>
    </Flex>
  )
}

export default DraggableTrackPreview
